import React from 'react';
import { ZapIcon } from 'lucide-react';
interface CopilotMessageProps {
  role: 'ai' | 'user';
  content: string;
  isTyping?: boolean;
  children?: React.ReactNode;
}
export function CopilotMessage({
  role,
  content,
  isTyping,
  children
}: CopilotMessageProps) {
  if (role === 'ai') {
    return <div className="flex items-start gap-3 animate-slide-in" data-id="element-44">
        <div className="w-8 h-8 rounded-full bg-primary/10 flex items-center justify-center shrink-0 mt-0.5" data-id="element-45">
          <ZapIcon className="w-4 h-4 text-primary" data-id="element-46" />
        </div>
        <div className="flex flex-col gap-2 max-w-[85%]" data-id="element-47">
          <div className="bg-muted rounded-2xl rounded-bl-md px-4 py-3 text-sm leading-relaxed text-foreground" data-id="element-48">
            {isTyping ? <div className="flex items-center gap-1.5 py-1 px-1" data-id="element-49">
                <span className="w-2 h-2 rounded-full bg-muted-foreground/50 animate-bounce" style={{
              animationDelay: '0ms'
            }} data-id="element-50" />
                <span className="w-2 h-2 rounded-full bg-muted-foreground/50 animate-bounce" style={{
              animationDelay: '150ms'
            }} data-id="element-51" />
                <span className="w-2 h-2 rounded-full bg-muted-foreground/50 animate-bounce" style={{
              animationDelay: '300ms'
            }} data-id="element-52" />
              </div> : content}
          </div>
          {children}
        </div>
      </div>;
  }
  return <div className="flex justify-end animate-slide-in" data-id="element-53">
      <div className="bg-primary text-primary-foreground rounded-2xl rounded-br-md px-4 py-3 text-sm leading-relaxed max-w-[85%]" data-id="element-54">
        {content}
      </div>
    </div>;
}